import trackEvent from "components/tracking/trackEvent";

export type PartnerMapAction =
	| "save_map"
	| "start_planning"
	| "whatsapp_signup"
	| "contact"
	| "tickets"
	/** the way to a place of the map (not the hostel) on Google Maps; `item` is the place's slug */
	| "place_map";

/** One event for every button of a partner map: what was pressed, and on what (`item`: a place's slug, an event's id, a contact channel). */
export const trackPartnerMap = (partner: string, action: PartnerMapAction, item?: string): void =>
	trackEvent("partner_map_action", { partner, action, ...(item ? { item } : {}) }, "marketing_site");
